module.exports = __webpack_public_path__ + "img/logo2.0f14af44.png";